/**
 * Overview menu card thumbnails (shared across partner / workspace / executive).
 * Assets: overviewThumbs/images/thumb-*.jpg (560×320). Replace via images/new thumbs → convert script in deploy notes or generate_portal_overview_thumbs.py (FLUX).
 */
import thumbDashboard from "./images/thumb-dashboard.jpg";
import thumbKpi from "./images/thumb-kpi.jpg";
import thumbSkin from "./images/thumb-skin.jpg";
import thumbHair from "./images/thumb-hair.jpg";
import thumbOps from "./images/thumb-ops.jpg";
import thumbAnalytics from "./images/thumb-analytics.jpg";
import thumbCustomers from "./images/thumb-customers.jpg";
import thumbStaff from "./images/thumb-staff.jpg";
import thumbStore from "./images/thumb-store.jpg";
import thumbAdmin from "./images/thumb-admin.jpg";
import thumbKiosk from "./images/thumb-kiosk.jpg";
import thumbSetup from "./images/thumb-setup.jpg";
import thumbExecutive from "./images/thumb-executive.jpg";
import thumbFlow from "./images/thumb-flow.jpg";
import thumbApps from "./images/thumb-apps.jpg";

import fallbackA from "../../salon-admin/assets/skin.png";
import fallbackB from "../../salon-admin/assets/makeup.png";

export const OVERVIEW_THUMB_ASSETS = {
  dashboard: thumbDashboard,
  kpi: thumbKpi,
  skin: thumbSkin,
  hair: thumbHair,
  ops: thumbOps,
  analytics: thumbAnalytics,
  customers: thumbCustomers,
  staff: thumbStaff,
  store: thumbStore,
  admin: thumbAdmin,
  kiosk: thumbKiosk,
  setup: thumbSetup,
  executive: thumbExecutive,
  flow: thumbFlow,
  apps: thumbApps,
};

/** Maps overview card `id` → thumb asset key. */
export const OVERVIEW_CARD_THUMB_KEY = {
  "network-dashboard": "dashboard",
  "salon-dashboard": "dashboard",
  "workspace-dashboard": "dashboard",
  "exec-dashboard": "executive",
  "network-kpis": "kpi",
  "salon-kpis": "kpi",
  "skin-network-kpis": "kpi",
  "skin-funnel": "skin",
  "skin-services": "skin",
  "skin-settings": "skin",
  "hair-funnel": "hair",
  "hair-services": "hair",
  "check-ins": "ops",
  "visit-services": "ops",
  "check-in-analytics": "analytics",
  "customer-analytics": "analytics",
  customers: "customers",
  "staff-report": "staff",
  "staff-analytics": "staff",
  "staff-availability": "staff",
  staff: "staff",
  "flow-all": "flow",
  engagement: "apps",
  whatsapp: "apps",
  "demo-engagement": "apps",
  reels: "flow",
  "reels-app": "apps",
  "price-list": "store",
  "product-list": "store",
  "my-orders": "store",
  apps: "apps",
  "kiosk-login": "apps",
  "dashboard-staff": "apps",
  "franchise-users": "admin",
  regions: "admin",
  licenses: "admin",
  "hq-admins": "admin",
  "company-profile": "executive",
  complaints: "admin",
  "contact-inbox": "admin",
  "location-requests": "admin",
  "geofence-settings": "kiosk",
  "kiosk-register-forms": "kiosk",
  "page-setup": "kiosk",
  "franchise-themes": "kiosk",
  "service-list-mapped": "setup",
  "service-list-management": "setup",
  "hub-performance": "dashboard",
  "hub-skin": "skin",
  "hub-hair": "hair",
  "hub-operations": "ops",
  "hub-engagement": "apps",
  "hub-reels": "flow",
  "hub-staff": "staff",
  "hub-store": "store",
  "hub-administration": "admin",
  "hub-setup": "setup",
  "hub-catalog-setup": "setup",
  "hub-kiosk": "kiosk",
};

const SECTION_THUMB_KEY = {
  performance: "dashboard",
  skin: "skin",
  hair: "hair",
  operations: "ops",
  engagement: "apps",
  whatsapp: "apps",
  reels: "flow",
  staff: "staff",
  store: "store",
  administration: "admin",
  setup: "setup",
  kiosk: "kiosk",
};

export function overviewThumbForCard(card) {
  if (!card) return fallbackA;
  const key = OVERVIEW_CARD_THUMB_KEY[card.id];
  if (key && OVERVIEW_THUMB_ASSETS[key]) return OVERVIEW_THUMB_ASSETS[key];
  return fallbackA;
}

export function overviewThumbForSection(sectionId) {
  const key = SECTION_THUMB_KEY[sectionId];
  if (key && OVERVIEW_THUMB_ASSETS[key]) return OVERVIEW_THUMB_ASSETS[key];
  return fallbackB;
}

export function withOverviewThumbs(cards) {
  if (!Array.isArray(cards)) return [];
  return cards.map((card) => ({
    ...card,
    image: overviewThumbForCard(card),
  }));
}
